import { getExaminationsOrdersOrderId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getOrderExaminationByOrderIdQueryKey = (orderId: number) => [
	"ORDER_EXAMINATION_BY_ORDER_ID",
	orderId,
];

export function useOrderExaminationByOrderIdQuery(
	orderId?: number,
	hasExamination?: boolean,
) {
	return useQuery({
		queryKey: getOrderExaminationByOrderIdQueryKey(orderId!),
		queryFn: processResponse(() => getExaminationsOrdersOrderId(orderId!)),
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId && hasExamination,
	});
}
